<div class="tags-search-container">
  <!-- Search -->
  <div class="search-wrapper">
    <input
      type="text"
      class="tags-search-input"
      [formControl]="tagSearchControl"
      [placeholder]="'page.risks.searchTags' | translate"
      (focus)="showSuggestions = true"
    />

    <!-- Suggestions dropdown -->
    <div class="suggestions-dropdown" *ngIf="showSuggestions && availableTags.length">
      <button type="button" class="suggestion-item" *ngFor="let tag of availableTags" (click)="selectTag(tag)">
        {{ "page.risks.tags." + tag | translate }}
      </button>
    </div>
  </div>

  <!-- Selected tags -->
  <div class="selected-tags" *ngIf="selectedTags.length">
    <div *ngFor="let tag of selectedTags" class="tag-chip">
      <span>{{ "page.risks.tags." + tag | translate }}</span>

      <button type="button" class="remove-btn" (click)="removeTag(tag)">✕</button>
    </div>
  </div>
</div>
